export const uploadConstants = {
  UPLOAD_ADD_FILE_TO_QUEUE: '[Upload] Add file to queue',
  UPLOAD_UPDATE_QUEUE: '[Upload] Update queue',
  UPLOAD_START_UPLOAD: '[Upload] Start uploading',
  UPLOAD_END_UPLOAD: '[Upload] End uploading',
  UPLOAD_CHUNK_FILE_TO_QUEUE: '[Upload] Add chunk to queue',
  UPLOAD_PROCESSING: '[Upload] Processing',
  UPLOAD_END_PROCESSING: '[Upload] End processing'
}
